/* Countdown */
$(document).ready(function () {
  var countDownDataRaw = $(".countdown-hero__count-container").data("countdown");
  var countDownDate = countDownDataRaw;

  var end = moment.tz(countDownDate, 'MM/DD/YYYY hh:mm a', 'Europe/London');

  var _second = 1000;
  var _minute = _second * 60;
  var _hour = _minute * 60;
  var _day = _hour * 24;
  var timer;

  function showRemaining() {
    var now = moment.tz('Europe/London');
    var distance = end.diff(now);

    // 🔒 Countdown running → hide ATC, show message
    if (distance > 0) {
      $("#buy-button-blk, .atc-product-form, .quick-add").hide();
      $("#countdown-message").show();
    }

    if (distance <= 0) {
      clearInterval(timer);

      $(".countdown-hero__count-container-content").addClass("count-down-ended");

      // ✅ Countdown ended → show ATC, hide message
      $("#buy-button-blk, .atc-product-form, .quick-add").show();
      $("#countdown-message").hide();

      // 🔁 Refresh page once when countdown ends
      if (!sessionStorage.getItem("countdownEnded")) {
        sessionStorage.setItem("countdownEnded", "true");
        location.reload();
      }

      return;
    }

    var days = Math.floor(distance / _day);
    var hours = Math.floor((distance % _day) / _hour);
    var minutes = Math.floor((distance % _hour) / _minute);
    var seconds = Math.floor((distance % _minute) / _second);

    document.getElementById("countdown").innerHTML =
      '<div><p class="number">' + days + '</p><p>days</p></div>' +
      '<div><p class="number">' + hours + '</p><p>hrs</p></div>' +
      '<div><p class="number">' + minutes + '</p><p>mins</p></div>' +
      '<div><p class="number">' + seconds + '</p><p>secs</p></div>';
  }

  timer = setInterval(showRemaining, 1000);
});
